<template>
  <div>
    <TopBar :page="topBarData" @menuItemClick="topMenuClicked"/>
    <v-container fluid>

      <v-row class="justify-center">

        <v-col cols="12" md="4"><CreditControl /></v-col>

        <v-col cols="12" md="3"><Payment /></v-col>

        <v-col cols="12" md="3"><Products /></v-col>

        <v-col cols="12" md="2"><Exclusion /></v-col>

      </v-row>

      <v-row>

        <v-col cols="12" md="8"><CreditControlHistory /></v-col>

        <v-col cols="12" md="4"><UddHistory /></v-col>
        
      </v-row>

    </v-container>

    <RecoverFromHandedOverConfirm v-model="recoverOpen" />
    <RecoverFromDead01Udd v-model="recoverFromDead01UddOpen" />

    <ConfirmationDialog v-model="confirmOpen" @confirmed="confirmed" @close="confirmOpen=false" :loading="getUpdateAccountLoading">
      <template #title>{{confirmTitle}}</template>
      <template #text>

        <template v-if="confirmType==='handover'">
          Are you sure you want to hand over this account?<br>
          The account will move to the "Handed Over" status
        </template>

        <template v-if="confirmType==='writeoff'">
          Are you sure you want to write off this account?<br>
          The account will move to the "Written Off" status
        </template>

        <template v-if="confirmType==='dead01Udd'">
          Are you sure you want to move this account?
        </template>

      </template>
    </ConfirmationDialog>
  </div>
</template>

<script>
  import { mapGetters,mapActions } from 'vuex';

  import TopBar from '../../components/Layout/TopBar';

  import CreditControl from '@/components/CreditControl/CreditControl';
  import Payment from '@/components/CreditControl/Payment';
  import Products from '@/components/CreditControl/Products';
  import Exclusion from '@/components/CreditControl/Exclusion';
  import RecoverFromHandedOverConfirm from '@/components/CreditControl/RecoverFromHandedOverConfirm';
  import CreditControlHistory from '@/components/CreditControl/CreditControlHistory';
  import UddHistory from '@/components/CreditControl/UddHistory';
  import RecoverFromDead01Udd from '@/components/CreditControl/RecoverFromDead01Udd';
  
  import ConfirmationDialog from '@/components/Globals/ConfirmationDialog';

  const ccUrl = process.env.VUE_APP_CC_API_HOST || `https://credit-control-testing-bonline.appspot.com/`;
  const ledgerUrl = process.env.VUE_APP_LEDGER_LINK || `https://ledger-test-bonline.appspot.com/`;

  export default {

    components: { TopBar,CreditControl,Payment,Products,Exclusion,RecoverFromHandedOverConfirm,ConfirmationDialog,CreditControlHistory,UddHistory,RecoverFromDead01Udd },

    computed: {
      ...mapGetters('creditControl',['getCreditControl','getUpdateAccountLoading','getUpdateAccountError']),
    },

    data() {
      return {
        recoverOpen: false,
        recoverFromDead01UddOpen: false,
        accountId: this.$route.params.id,
        confirmOpen: false,
        confirmType: '',
        confirmTitle: '',
        confirmText: '',

        topBarData: {
          name: 'loading...',
          type: 'creditControl',
          showSearch: true,
          breadcrumbs: [
            {
              text: 'Billing Accounts',
              disabled: false,
              href: '/accounts/',
            }
          ],
          showBeehiveIcon: false,
        },
      }
    },

    methods: {
      ...mapActions('creditControl',['fetchCreditControl','updateAccount']),
    
      topMenuClicked(menuItem){
        switch (menuItem) {
          case "recoverFromHandedOver":
            this.recoverOpen = true;
            break;
          case "goToOldCc":
            window.open(`${ccUrl}account/${this.accountId}`);
            break;
          case "goToLedger":
            window.open(`${ledgerUrl}transactions/${this.accountId}`);
            break;
          case "handOver":
            this.confirmType = 'handover';
            this.confirmTitle = 'Hand Over';
            this.confirmOpen = true;
            break;
          case "writeOff":
            this.confirmType = 'writeoff';
            this.confirmTitle = 'Write Off';
            this.confirmOpen = true;
            break;
          case "dead01Udd":
            this.confirmType = 'dead01Udd';
            this.confirmTitle = 'Dead 01 UDD';
            this.confirmOpen = true;
            break;
          case 'recoverFromDead01Udd':
            if (this.getCreditControl.status === 'Dead 01 UDD') {
              this.recoverFromDead01UddOpen = true;
            }
            break;
        }
      },

      async confirmed() {
        let status = '';

        switch(this.confirmType) {
          case 'handover':
            status = 'Handed Over';
            break;
          case 'writeoff':
            status = 'Write Off';
            break;
          case 'dead01Udd':
            status = 'Dead 01 UDD';
            break;
        }
        
        await this.updateAccount({account_id:this.accountId,data:{status:status}});
        this.confirmOpen = false;
        if(!this.getUpdateAccountError){
          this.fetchCreditControl(this.accountId);
        }
      },

    },

    async created () {
      await this.fetchCreditControl(this.accountId);
      this.topBarData.name = `${this.getCreditControl.customer_id} - ${this.getCreditControl.business_name}`;
      this.topBarData.breadcrumbs.push(
        {
          text: `${this.getCreditControl.customer_id} - ${this.getCreditControl.business_name}`,
          disabled: false,
          href: `/accounts/${this.getCreditControl.customer_id}`,
        },
        {
          text: `Credit Control`,
          disabled: true,
          href: ``,
        }
      );
    },
    
  }
</script>

<style lang="scss" scoped>

</style>
